<template>
  <q-layout view="hHh lpR fFf" class="auth-layout">
    <q-page-container>
      <q-page class="auth-shell" data-testid="auth-shell">
        <div class="auth-shell__main">
          <div class="auth-shell__brand">
            <img src="/brand/logo.png" width="196" height="52" alt="Комбу">
          </div>
          <slot />
          <footer class="auth-shell__footer">
            <button type="button" class="auth-shell__legal" @click="legalOpen = true">
              Пользовательское соглашение
            </button>
            <span aria-hidden="true">·</span>
            <span>Безопасная работа с данными организации</span>
          </footer>
        </div>
      </q-page>
    </q-page-container>

    <q-dialog v-model="legalOpen" maximized-on-mobile>
      <privacy-policy />
    </q-dialog>
  </q-layout>
</template>

<script>
import PrivacyPolicy from '../../views/core/privacy_policy.vue'

export default {
  name: 'AuthShell',
  components: { PrivacyPolicy },
  data() {
    return { legalOpen: false }
  }
}
</script>

<style scoped>
.auth-layout { background: var(--sid-color-surface-canvas); }
.auth-shell { min-height: 100vh; padding: max(var(--sid-space-6), env(safe-area-inset-top)) var(--sid-page-gutter-mobile) max(var(--sid-space-5), env(safe-area-inset-bottom)); background: var(--sid-color-surface-canvas); }
.auth-shell__main { display: flex; width: 100%; min-height: calc(100vh - var(--sid-space-8)); align-items: center; justify-content: center; flex-direction: column; }
.auth-shell__brand { display: flex; align-items: center; gap: var(--sid-space-2); margin-bottom: var(--sid-space-5); color: var(--sid-color-text-primary); font-size: var(--sid-font-size-section); font-weight: var(--sid-font-weight-semibold); letter-spacing: 0.02em; }
.auth-shell__brand img { display: block; width: 12.25rem; max-width: 100%; height: auto; }
.auth-shell__footer { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: var(--sid-space-2); margin-top: var(--sid-space-5); color: var(--sid-color-text-muted); font-size: var(--sid-font-size-label); line-height: var(--sid-line-height-label); text-align: center; }
.auth-shell__legal { padding: var(--sid-space-1); border: 0; background: transparent; color: var(--sid-color-brand-600); cursor: pointer; text-decoration: underline; text-underline-offset: 0.18em; }

@media (min-width: 600px) {
  .auth-shell { padding-right: var(--sid-page-gutter-tablet); padding-left: var(--sid-page-gutter-tablet); }
}

@media (max-width: 599px) {
  .auth-shell { padding-top: max(var(--sid-space-4), env(safe-area-inset-top)); }
  .auth-shell__main { min-height: calc(100vh - var(--sid-space-6)); align-items: stretch; justify-content: flex-start; }
  .auth-shell__brand { margin: 0 auto var(--sid-space-4); }
  .auth-shell__footer { margin-top: auto; padding-top: var(--sid-space-5); }
  .auth-shell__legal { min-height: var(--sid-touch-target); }
}
</style>
